"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizedString = void 0;
class LocalizedString {
    constructor() {
        this['en-US'] = '';
        this.de = '';
        this.es = '';
        this.fr = '';
        this.it = '';
        this.ja = '';
        this.pt = '';
        this['zh-CN'] = '';
        this.nl = '';
        this.nb = '';
        this.da = '';
        this.ko = '';
    }
}
exports.LocalizedString = LocalizedString;
//# sourceMappingURL=localized-string.model.js.map